// src/pages/Appli/AppliAdmin/users-admin/components/LinkClubModal.jsx

import React from "react";

import { Modal } from "../../../../../components/Modal/Modal";

import { ROLES_IN_CLUB } from "../data/usersAdmin.data";

export default function LinkClubModal({
  modal,
}) {
  return (
    <Modal
      isOpen={modal.isOpen}
      onClose={modal.close}
      size="lg"
      labelledById="link-club-title"
      describedById="link-club-description"
    >
      <div className="p-4 sm:p-5">
        <h2
          id="link-club-title"
          className="text-lg font-semibold text-slate-900 dark:text-white"
        >
          Lier un club à{" "}
          {modal.targetUser
            ? `${modal.targetUser.nom} ${modal.targetUser.prenom}`
            : "l’utilisateur"}
        </h2>

        <p
          id="link-club-description"
          className="mt-1 text-sm text-slate-600 dark:text-slate-300"
        >
          Sélectionnez un club et le rôle occupé par l’utilisateur.
        </p>

        <form
          onSubmit={modal.submit}
          className="mt-5 grid gap-3 md:grid-cols-3"
        >
          <div>
            <label className="text-xs uppercase tracking-wide text-slate-500">
              Département
            </label>

            <select
              value={modal.linkDepartement}
              onChange={(event) =>
                modal.setLinkDepartement(event.target.value)
              }
              className="mt-1 h-11 w-full rounded-2xl border border-slate-300 bg-white px-3 text-sm dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            >
              <option value="">Tous</option>

              {modal.departements.map((departement) => (
                <option
                  key={departement}
                  value={departement}
                >
                  {departement}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-xs uppercase tracking-wide text-slate-500">
              Club
            </label>

            <select
              value={modal.selectedClubId}
              onChange={(event) =>
                modal.setSelectedClubId(event.target.value)
              }
              required
              className="mt-1 h-11 w-full rounded-2xl border border-slate-300 bg-white px-3 text-sm dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            >
              <option value="">
                {modal.visibleClubs.length
                  ? "Choisir un club"
                  : "Aucun club trouvé"}
              </option>

              {modal.visibleClubs.map((club) => (
                <option
                  key={club.id}
                  value={club.id}
                >
                  {club.nom_club}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-xs uppercase tracking-wide text-slate-500">
              Rôle dans le club
            </label>

            <select
              value={modal.roleInClub}
              onChange={(event) =>
                modal.setRoleInClub(event.target.value)
              }
              required
              className="mt-1 h-11 w-full rounded-2xl border border-slate-300 bg-white px-3 text-sm dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            >
              {ROLES_IN_CLUB.map((role) => (
                <option
                  key={role}
                  value={role}
                >
                  {role}
                </option>
              ))}
            </select>
          </div>

          <div className="md:col-span-3">
            <label className="text-xs uppercase tracking-wide text-slate-500">
              Rechercher un club
            </label>

            <input
              type="text"
              value={modal.linkSearch}
              onChange={(event) =>
                modal.setLinkSearch(event.target.value)
              }
              placeholder="Ex. : Dojo Bordeaux"
              className="mt-1 h-11 w-full rounded-2xl border border-slate-300 bg-white px-3 text-sm dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            />
          </div>

          <div className="md:col-span-3 flex justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={modal.close}
              className="inline-flex h-10 items-center rounded-2xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
            >
              Annuler
            </button>

            <button
              type="submit"
              disabled={modal.linking || !modal.selectedClubId}
              className="inline-flex h-10 items-center rounded-2xl bg-indigo-600 px-4 text-sm font-semibold text-white disabled:opacity-50"
            >
              {modal.linking ? "Liaison…" : "Lier ce club"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}